module.exports = __webpack_public_path__ + "img/地域.6b803c98.png";